import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import DevicesProvider from './context/DevicesProvider';
import DevicesBody from './DevicesBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const Devices = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <DevicesProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="CNMAESTRO - Devices" position={firstName} />
          <DevicesBody />
        </main>
        <ToastContainer />
      </DevicesProvider>
    </div>
  );
};

export default Devices;
